import { ArrowRightOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import React from 'react';
import { Button, Card, Divider, Flex, Typography } from 'zui/Antd';

const { Title, Text } = Typography;

const QuickViewCard = ({ icon, number, title, buttonText }) => {
	const {
		token: {
			colorPrimary,
			borderRadius,
			borderRadiusLG,
			colorWhite,
			fontSizeSM,
			fontWeightStrong,
			paddingXXS,
			colorTextLabel,
			paddingSM
		}
	} = theme.useToken();

	return (
		<Card
			style={{
				borderRadius: borderRadius,
				padding: paddingSM
			}}
			styles={{
				body: {
					padding: 0
				}
			}}
		>
			{/* Icon & Number */}
			<Flex gap={16} align='center' style={{ paddingBottom: paddingXXS }}>
				<Flex
					style={{
						width: 50,
						height: 50,
						borderRadius: borderRadiusLG,
						backgroundColor: colorPrimary,
						color: colorWhite,
						fontSize: 34
					}}
					align='center'
					justify='center'
				>
					{icon}
				</Flex>
				<Flex vertical>
					<Title level={2} style={{ margin: 0 }}>
						{number}
					</Title>
					<Text
						style={{
							fontSize: fontSizeSM,
							fontWeight: fontWeightStrong
						}}
					>
						{title}
					</Text>
				</Flex>
			</Flex>

			{/* Divider */}
			<Divider
				style={{
					width: '100%',
					margin: '11px 0'
				}}
			/>

			{/* Button Section */}
			<Button
				style={{
					fontSize: 14,
					color: colorTextLabel
				}}
				icon={
					<ArrowRightOutlined
						style={{
							margin: 0
						}}
					/>
				}
				iconPosition='start'
				type='link'
			>
				{buttonText}
			</Button>
		</Card>
	);
};

export default QuickViewCard;
